module.exports = __webpack_public_path__ + "img/jianjietopmin.8f80075c.jpg";